<template>
  <div class="tw-flex tw-flex-col">
    <div class="">
      <div v-if="isLoading" class="tw-p-4">
        <div class="tw-space-y-3">
          <base-skeleton-loader class="tw-h-12 tw-w-full" />
          <base-skeleton-loader v-for="i in 5" :key="i" class="tw-h-10 tw-w-full" />
        </div>
      </div>
      <base-table :fields="fields" :items="items" :overflowVisible="true" v-else>
        <template #existing="{ item }">
          <div>{{ item.continuing + item.converted + item.addition }}</div>
        </template>
      </base-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChurnProjectionSummary",
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      showExisting: false,
      fields: [
        { title: "", key: "month", thClass: "tw-text-center", tdClass: "tw-text-center" },
        {
          title: "Active Plans",
          key: "activePlans",
          thClass: "tw-text-center",
          tdClass: "tw-text-center",
          tooltip:
            "This represents the total number of active plans including your New Patients, Existing Patients, and the variants of Existing Patients such as Continuing or Converted ones.",
        },
        {
          title: "New Pt.",
          key: "newPt",
          thClass: "tw-text-center",
          tdClass: "tw-text-center",
          tooltip:
            "This represents the number of Patients who received a Prescription and successfully started their journey with an active plan. These patients have not had an active plan within the past 30 days.",
        },
        {
          title: "Existing",
          key: "existing",
          thClass: "tw-text-center tw-cursor-pointer",
          tdClass: "tw-text-center",
          onClick: this.showExistingPlans,
          tooltip: "This represents the sum of all variations of Existing Patients. Click on Existing Patients to view a breakdown. Click again to hide.",
        },
        {
          title: "Terminated",
          key: "terminated",
          thClass: "tw-text-center",
          tdClass: "tw-text-center",
          tooltip:
            "This represents how many patients have fully cancelled out. There is no planned or ongoing charge on their profile since the last 30-days. This can be due to completion, pausing, or a delay in their medication.",
        },
      ],
      existingFields: [
        {
          title: "Continuing",
          key: "continuing",
          thClass: "tw-text-center tw-bg-primary-100",
          tdClass: "tw-text-center tw-bg-primary-100",
          tooltip: "This number represents how many of your existing patients have remained on the original plan that they started on.",
        },
        {
          title: "Converted",
          key: "converted",
          thClass: "tw-text-center tw-bg-primary-100",
          tdClass: "tw-text-center tw-bg-primary-100",
          tooltip: "This represents how many of your existing patients have switched to a different plan since starting, meaning they’re no longer on the original plan.",
        },
        {
          title: "Addition",
          key: "addition",
          thClass: "tw-text-center tw-bg-primary-100",
          tdClass: "tw-text-center tw-bg-primary-100",
          tooltip:
            "This represents how many of your existing patients have added a new plan on top of an already continuing one. This means these patients have more than one active plan at the same time.",
        },
      ],
      items: [
        {
          month: "October",
          newPt: 5,
          activePlans: 5,
          continuing: null,
          converted: null,
          addition: null,
          terminated: null,
        },
        {
          month: "November",
          newPt: 0,
          activePlans: 6,
          continuing: null,
          converted: null,
          addition: 1,
          terminated: null,
        },
        {
          month: "December",
          newPt: 2,
          activePlans: 8,
          continuing: 2,
          converted: null,
          addition: 1,
          terminated: null,
        },
        {
          month: "January",
          newPt: 2,
          activePlans: 10,
          continuing: 2,
          converted: 2,
          addition: 1,
          terminated: null,
        },
        {
          month: "February",
          newPt: 0,
          activePlans: 7,
          continuing: 2,
          converted: null,
          addition: null,
          terminated: 3,
        },
      ],
    };
  },
  created() {
    // Simulate loading state
    this.simulateLoading();
  },
  watch: {
    showExisting(newVal) {
      if (newVal) {
        // Add existing fields back after existing field
        this.fields = [...this.fields.slice(0, 4), ...this.existingFields, ...this.fields.slice(4)];
      } else {
        this.fields = this.fields.filter((field) => !["continuing", "converted", "addition"].includes(field.key));
      }
    },
  },
  methods: {
    simulateLoading() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    showExistingPlans() {
      this.showExisting = !this.showExisting;
    },
  },
};
</script>
